module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSJyZWQiIGQ9Ik0wIDBoMjEzLjMzM3Y0ODBIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiNmZjAiIGQ9Ik0yMTMuMzMzIDBoMjEzLjMzM3Y0ODBIMjEzLjMzM3oiLz4KICAgIDxwYXRoIGZpbGw9IiMwOTAiIGQ9Ik00MjYuNjY2IDBINjQwdjQ4MEg0MjYuNjY1eiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/gn.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/gn.svg
// module chunks = 0